// export const NAVER_MAP_CLIENT_ID = '8tchgu55fw' //'cv5t0z6m5a'//'8tchgu55fw'; //'3kasfq6p3w'
// export const NAVER_MAP_CLIENT_KEY = 'ynTflPnwB2jcYHpoYQIhxRixN0hCBQ8C8sX9729D'//'9MzPAiJlCYdWfT79a8Y5LK56vdiivNUYksoUWiYF'//'ynTflPnwB2jcYHpoYQIhxRixN0hCBQ8C8sX9729D'; //'moG7IjGrLYOSrjkIDqLA6uVHVMB7b60vjsTeQpik'


// export const NAVER_MAP_CLIENT_ID = 'cv5t0z6m5a' //'cv5t0z6m5a'//'8tchgu55fw'; //'3kasfq6p3w'
// export const NAVER_MAP_CLIENT_KEY = '9MzPAiJlCYdWfT79a8Y5LK56vdiivNUYksoUWiYF'


export const NAVER_MAP_CLIENT_ID = 'fosj2odxos' //'cv5t0z6m5a'//'8tchgu55fw'; //'3kasfq6p3w'
export const NAVER_MAP_CLIENT_KEY = 'Dc9wo6yrVSlQvs5ynt1ShuJAyfB1LdZjVNqpmjVU'//